import { customSeriesDefaultOptions, CustomSeriesOptions, IChartApi, Time } from 'lightweight-charts'
import { callColorCumulative, putColorCumulative } from '../../../multiStikeChart/styles'

export type StackedBarsSeriesOptions = CustomSeriesOptions & {
    colors: readonly string[]
    barWidth: number
    increaseWidthOnHover: boolean
    disablePadding: boolean
    hoveredTime?: Time,
    chartApi?: IChartApi
}

export const defaultOptions: StackedBarsSeriesOptions = {
    ...customSeriesDefaultOptions,
    colors: [
        callColorCumulative+'80',
        putColorCumulative+'80'
    ],
    barWidth: 1,
    increaseWidthOnHover: false,
    disablePadding: false
}
